export function ServerTimeDao(RESOURCE, ArtifactoryDaoFactory) {
    return ArtifactoryDaoFactory()
            .setPath(RESOURCE.SERVER_TIME)
            .setCustomActions({
            	'get': {
                    method: 'GET'
				}
            })
            .getInstance();
}


// WEBPACK FOOTER //
// ./data/dao/server_time_dao.js